export const addEmailListener = () => {
    const submitButton = document.querySelector('.signup-form__submit');
    const theForm = document.querySelector('.signup-form');
    const formInput = document.querySelector('.signup-form__field.required');
    const newsletter = document.querySelector('.mcapi');
    const formData = new FormData();

    let pass = false;

    const validateEmail = (inp) => {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(inp);
    };

    const validateForm = () => {
        theForm.classList.remove('fix');
        theForm.classList.remove('success');
        if (!validateEmail(formInput.value)) {
            theForm.classList.add('fix');
            pass = false;
        } else {
            formData.append('email', formInput.value);
            formData.append('newsletter', newsletter.value);
            pass = true;
            formInput.value = '';
        }
    };

    const submitForm = () => {
        validateForm();

        if (pass) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/wp-content/themes/starfish/email.php');
            xhr.send(formData);
            theForm.classList.add('success');
        }

        return pass;
    };
    submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        submitForm();
    });
};

addEmailListener();
